import React from 'react';
import { useState } from 'react';

//
// Tab control element.
//
// Pages, typically <div>, are children of the <TabWidget>.
// Each child has a 'title' property that is unique to the child set.
// Element has 2 optional properties:
//   selected - title of child to be displayed on first render
//   onSelect - callback function on tab selection (click) of form
//                 function(title) {...} -> (void)
//
// Example 1 (fixed content, starting on page One):
// <TabWidget onSelect={onSelect} selected="One">
//     <h2 id="w_Zero" title="Zero">No content!</h2>
//     <h2 id="w_One" title="One">I'm number 1!</h2>
//     <h2 id="w_Two" title="Two">Still second fiddle</h2>
// </TabWidget>
//
// Example 2 (data is a useState() object):
// <TabWidget onSelect={onSelect}>                                                                                                                                                                                                  
//     {
//         data && data.items.map(item => (
//             <div title={item.title}>{item.body}</div>
//         ))
//     }
// </TabWidget>
//
let gCounter = 0;

const TabWidget = (props) => {
    const [selected, setSelected] = useState("");
    const [titles, setTitles] = useState([]);
    const [count, setCount] = useState(0);
    const [id, setId] = useState(`w_Tab_${gCounter++}`);

    let headers = [];
    let element;
    React.Children.map(props.children, child => {
        headers.push(child.props.title);
        if (child.props.title === selected) {
            element = child;
        }
    });

    if (props && props.children && props.children.length != count) {
        setTitles(headers);
        setCount(props.children.length);

        if (props && props.hasOwnProperty("selected")) {
            show(props.selected);
        } else {
            show(headers[0]);
        }
    }

    function show(name) {
        setSelected(name);

        if (props && props.onSelect) {
            props.onSelect(name);
        }
    }

    function link(title) {
        if (title === selected) {
            return "nav-link active";
        }

        return "nav-link";
    }

    return (
        <div>
            <ul className="nav nav-tabs">
                {
                    titles.map((title) => (
                        <li className="nav-item">
                            <a className={link(title)} data-bs-toggle="tab" href={'#' + id} id={id}
                                onClick={() => show(title)}>{title}</a>
                        </li>
                    ))
                }
            </ul>
            {element}
        </div>
    )
}

export default TabWidget;
